import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { useAuthStore } from '~/stores/auth';
export default function (_x, _x2) {
  return _ref.apply(this, arguments);
}
function _ref() {
  _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(context, inject) {
    var authStore;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          authStore = useAuthStore(context.$pinia); // Make $auth global
          inject('auth', authStore);
          context.$auth = authStore;

          // Fetch initial state
          _context.prev = 3;
          _context.next = 6;
          return authStore.fetch();
        case 6:
          _context.next = 11;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](3);
          // Not authorized
          // Check axios module is correctly registered
          if (!context.$axios) {
            /* eslint-disable no-console */
            console.error('[CASES]', 'Please make sure @nuxtjs/axios is added after this module!');
          }
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 8]]);
  }));
  return _ref.apply(this, arguments);
}